// Service-area landing pages (/ceiling-drywall-supplies/:slug).
// Each entry needs genuinely local copy — avoid copy-pasting the same text between towns,
// search engines treat near-identical location pages as doorway pages.

export const AREA_BASE_PATH = '/ceiling-drywall-supplies';

export const locations = [
  {
    slug: 'mossel-bay',
    name: 'Mossel Bay',
    region: 'Garden Route',
    distance: 'about 50 km west of our George warehouse on the N2',
    nearby: ['Hartenbos', 'Great Brak River', 'Klein Brak River', 'Dana Bay', 'Reebok', 'Tergniet'],
    intro:
      'Mossel Bay is one of our busiest delivery routes. From new homes in Hartenbos and Dana Bay to shopfitting, offices and industrial units around the harbour and Voorbaai, contractors rely on OJANNA Ceiling & Drywall Distributors for ceiling boards, drywall partitioning and insulation delivered straight from George.',
    focus: [
      {
        title: 'Coastal-grade drywall',
        text: 'Salt air and humidity are hard on interiors near the sea. We stock moisture-resistant plasterboard from Gyproc, Siniat and SuperTec, plus corrosion-resistant aluminium profiles for bathrooms, kitchens and seafront homes.',
      },
      {
        title: 'Commercial & industrial fit-outs',
        text: 'Exposed grid ceilings in white, black and grey, acoustic ceiling tiles and complete partitioning systems for offices, retail and warehouse mezzanines.',
      },
      {
        title: 'Roof insulation',
        text: 'Knauf Insulation, Isotherm, Aerolite and Youngman insulation to help new builds meet SANS 10400-XA energy requirements.',
      },
    ],
  },
  {
    slug: 'knysna',
    name: 'Knysna',
    region: 'Garden Route',
    distance: 'about 60 km east of George on the N2',
    nearby: ['Brenton-on-Sea', 'Belvidere', 'Rheenendal', 'Buffalo Bay', 'Sedgefield'],
    intro:
      'Knysna builders and renovators order ceiling, drywall and insulation materials from OJANNA Ceiling & Drywall Distributors in George for everything from holiday homes on Leisure Isle and Thesen Island to restaurants, guest houses and commercial refurbishments in town.',
    focus: [
      {
        title: 'Damp-proof interiors',
        text: 'The lagoon and forest climate means high humidity. Moisture-resistant plasterboard, fibre cement boards from RhinoROC and Nutec, and the right jointing compounds keep ceilings and walls stable.',
      },
      {
        title: 'Hospitality & retail fit-outs',
        text: 'WoodUpp acoustic wall panels, OWA acoustic ceiling tiles and drywall partitions for restaurants, venues and shopfronts where sound control and finish matter.',
      },
      {
        title: 'Renovations',
        text: 'Steel brandering, plaster grid and skimming plasters from Siniat, Casofour and iTe for upgrading older ceilings and bulkheads.',
      },
    ],
  },
  {
    slug: 'plettenberg-bay',
    name: 'Plettenberg Bay',
    region: 'Garden Route',
    distance: 'about 95 km east of George on the N2',
    nearby: ['Keurboomstrand', 'Wittedrift', 'Kranshoek', 'The Crags', 'Natures Valley'],
    intro:
      'High-end residential projects keep Plettenberg Bay contractors busy, and OJANNA Ceiling & Drywall Distributors supplies the ceiling systems, drywall, insulation and acoustic finishes they need — delivered from our George warehouse so you are not waiting on stock from Cape Town or Gqeberha.',
    focus: [
      {
        title: 'Premium finishes',
        text: 'Seamless plastered ceilings on plaster grid with aluminium profiles, WoodUpp acoustic wall and ceiling cladding, and quality skimming plasters for a flawless finish.',
      },
      {
        title: 'Built for the coast',
        text: 'Moisture-resistant and fire-resistant plasterboard from Gyproc, Siniat and SuperTec, and RhinoROC fibre cement for covered patios, eaves and exposed areas.',
      },
      {
        title: 'Comfort & energy efficiency',
        text: 'Thermal and acoustic insulation from Knauf, Isotherm, Aerolite and Youngman for holiday homes and lodges that need to stay cool in summer and warm in winter.',
      },
    ],
  },
  {
    slug: 'wilderness-sedgefield',
    name: 'Wilderness & Sedgefield',
    region: 'Garden Route',
    distance: 'about 15 km (Wilderness) and 40 km (Sedgefield) east of George',
    nearby: ['Wilderness', 'Hoekwil', 'Kleinkrantz', 'Sedgefield', 'Karatara', 'Swartvlei'],
    intro:
      'Wilderness and Sedgefield sit right on our doorstep, so builders and homeowners in the lakes area can collect from our George showroom or have OJANNA Ceiling & Drywall Distributors deliver ceiling boards, drywall and insulation to site.',
    focus: [
      {
        title: 'Homes near the water',
        text: 'Moisture-resistant plasterboard and fibre cement boards for homes along the lakes and coastline, plus corrosion-resistant fixings and profiles.',
      },
      {
        title: 'Ceiling insulation upgrades',
        text: 'Youngman Youngtherm, Isotherm, Aerolite and Knauf Insulation for retrofitting older houses and holiday homes.',
      },
      {
        title: 'Quick turnaround',
        text: 'Being this close to George means quick delivery, or you can collect from our showroom in Joubert Industria.',
      },
    ],
  },
  {
    slug: 'oudtshoorn',
    name: 'Oudtshoorn',
    region: 'Klein Karoo',
    distance: 'about 60 km north of George over the Outeniqua Pass',
    nearby: ['Dysselsdorp', 'De Rust', 'Schoemanshoek', 'Calitzdorp'],
    intro:
      'Oudtshoorn is our gateway to the Klein Karoo. OJANNA Ceiling & Drywall Distributors supplies Oudtshoorn builders, farmers and homeowners with ceiling systems, insulation and drywall materials — just over the Outeniqua Pass from our George warehouse.',
    focus: [
      {
        title: 'Insulation for Karoo extremes',
        text: 'Scorching summers and cold winters make roof and ceiling insulation essential. We stock Knauf Insulation, Isotherm, Aerolite and Youngman radiant barriers and insulation blankets.',
      },
      {
        title: 'Farm & agricultural buildings',
        text: 'Ceiling boards, steel brandering and insulation for farmhouses, sheds, packing facilities and guest accommodation.',
      },
      {
        title: 'Schools, clinics & offices',
        text: 'Exposed grid ceilings, acoustic tiles and drywall partitioning for public and commercial buildings.',
      },
    ],
  },
  {
    slug: 'klein-karoo',
    name: 'the Klein Karoo',
    region: 'Klein Karoo',
    distance: 'beyond Oudtshoorn, north of George over the Outeniqua Pass',
    nearby: ['Calitzdorp', 'De Rust', 'Prince Albert', 'Ladismith', 'Uniondale', 'Dysselsdorp'],
    intro:
      'Beyond Oudtshoorn, OJANNA Ceiling & Drywall Distributors delivers ceiling, drywall and insulation supplies to Calitzdorp, De Rust, Prince Albert, Ladismith, Uniondale and the farms in between. Contact us to plan a delivery to your site.',
    focus: [
      {
        title: 'Thermal performance',
        text: 'Ceiling insulation and radiant barriers are the most cost-effective way to keep Karoo homes and guest farms comfortable year round.',
      },
      {
        title: 'Restoring older buildings',
        text: 'Plasterboard, brandering, plaster grid and skimming plasters for restoring historic Karoo houses and converting outbuildings.',
      },
      {
        title: 'One supplier, one delivery',
        text: 'Combine ceilings, drywall, insulation, ladders and tools in a single order to make the most of each trip.',
      },
    ],
  },
  {
    slug: 'riversdale-stilbaai',
    name: 'Riversdale & Stilbaai',
    region: 'Hessequa',
    distance: 'about 130 km west of George on the N2',
    nearby: ['Albertinia', 'Riversdale', 'Stilbaai', 'Jongensfontein', 'Heidelberg', 'Witsand'],
    intro:
      'The Hessequa towns between Mossel Bay and Swellendam are on our western delivery route. OJANNA Ceiling & Drywall Distributors supplies ceiling boards, drywall, insulation and acoustic products to contractors and homeowners in Albertinia, Riversdale, Stilbaai and Heidelberg.',
    focus: [
      {
        title: 'Coastal & inland projects',
        text: 'Moisture-resistant plasterboard for Stilbaai and Jongensfontein holiday homes, and insulation for hotter inland towns like Riversdale and Heidelberg.',
      },
      {
        title: 'Full ceiling systems',
        text: 'Ceiling tiles, exposed grid and plaster grid, steel brandering, fasteners and tools — everything for a complete ceiling installation.',
      },
      {
        title: 'Partitioning',
        text: 'Tracks, studs, nogging and aluminium door frames from Swartland for offices, shops and agricultural buildings.',
      },
    ],
  },
  {
    slug: 'swellendam',
    name: 'Swellendam',
    region: 'Overberg',
    distance: 'about 230 km west of George on the N2',
    nearby: ['Buffeljagsrivier', 'Suurbraak', 'Barrydale', 'Bonnievale', 'Cape Agulhas'],
    intro:
      'Swellendam and the eastern Overberg are on our route to Cape Town. OJANNA Ceiling & Drywall Distributors delivers ceiling, drywall, insulation and acoustic supplies to builders working on homes, guest houses and farm buildings in the area.',
    focus: [
      {
        title: 'Heritage & guest houses',
        text: 'Plaster grid, plasterboard and skimming plasters for sympathetic renovations, with acoustic wall panels for venues and restaurants.',
      },
      {
        title: 'Insulation',
        text: 'Thermal insulation and radiant barriers from Knauf, Isotherm, Aerolite and Youngman for hot Overberg summers.',
      },
      {
        title: 'Bulk orders',
        text: 'Plan bigger orders with our sales team so materials arrive together and on time.',
      },
    ],
  },
  {
    slug: 'cape-town',
    name: 'Cape Town',
    region: 'Western Cape',
    distance: 'about 430 km west of George on the N2',
    nearby: ['Cape Town CBD', 'Northern Suburbs', 'Southern Suburbs', 'Somerset West', 'Stellenbosch', 'Paarl'],
    intro:
      'OJANNA Ceiling & Drywall Distributors supplies contractors and developers in Cape Town and the Boland with ceiling systems, drywall, insulation and acoustic products. As master distributor for SuperTec, ETEX, Siniat and OWA, we offer sharp pricing on project quantities delivered from George.',
    focus: [
      {
        title: 'Commercial ceilings',
        text: 'Exposed grid in white, black and grey, acoustic and vinyl ceiling tiles from OWA and SuperTec for offices, schools and retail.',
      },
      {
        title: 'Drywall systems',
        text: 'Plasterboard from Gyproc, Siniat and SuperTec with steel brandering, partitioning components, aluminium profiles and Swartland aluminium door frames.',
      },
      {
        title: 'Acoustic projects',
        text: 'OWA ceiling tiles and WoodUpp acoustic wall panels for studios, auditoriums, boardrooms and hospitality venues.',
      },
    ],
  },
  {
    slug: 'port-elizabeth-gqeberha',
    name: 'Port Elizabeth (Gqeberha)',
    region: 'Eastern Cape',
    distance: 'about 330 km east of George via the N2 and Tsitsikamma',
    nearby: ['Tsitsikamma', 'Storms River', 'Humansdorp', 'Jeffreys Bay', 'the Eastern Cape'],
    intro:
      'Our eastern route runs from Plettenberg Bay through Tsitsikamma to Humansdorp, Jeffreys Bay and Gqeberha (Port Elizabeth). OJANNA Ceiling & Drywall Distributors supplies ceiling, drywall, insulation and acoustic materials to contractors along the way.',
    focus: [
      {
        title: 'Coastal construction',
        text: 'Moisture-resistant boards, fibre cement and corrosion-resistant profiles for the wind- and salt-exposed Eastern Cape coast.',
      },
      {
        title: 'Commercial & industrial',
        text: 'Exposed grid ceilings, partitioning systems and fire-resistant plasterboard for factories, offices and retail.',
      },
      {
        title: 'Insulation',
        text: 'Roof and ceiling insulation from leading brands for energy-efficient new builds and retrofits.',
      },
    ],
  },
];

export const getLocationBySlug = (slug) => locations.find((l) => l.slug === slug);
export const locationPath = (location) => `${AREA_BASE_PATH}/${location.slug}`;
